import * as _ from "underscore";
import { LOCATION_CHANGE } from "react-router-redux";

import { SEARCH_DATA_LOADED } from "web_modules/redux/searchLoans/types";
import { actionTypes } from "./actions";

// Known bug issue in immutability-helper package
// Fix to be released soon:
// https://github.com/kolodny/immutability-helper/pull/98
//
// import update from "immutability-helper";
const update: any = require("immutability-helper");

/* helpers */

const appIdToIdx = (apps, appId) => _.findIndex(apps, (a: any) => a.id === appId);

const overrideIdToHurdleIdx = (hurdles, overrideId) =>
  _.findIndex(hurdles, (h: any) => h.override && h.override.id === overrideId);

/* reducer */

export interface OperatorDashboardStateShape {
  loading: boolean;
  loanApps: any;
  wvoeHurdleViewingEmploymentID: number;
  previousLocation: string;
  currentLocation: string;
  currentHurdleName: string | null;
}

const initialState: OperatorDashboardStateShape = {
  loading: true,
  loanApps: null,
  wvoeHurdleViewingEmploymentID: 0,
  previousLocation: null,
  currentLocation: null,
  currentHurdleName: null,
};

export const underwriterDashboardReducer = (
  state: OperatorDashboardStateShape = initialState,
  action,
): OperatorDashboardStateShape => {
  const { type } = action;

  // TODO: jjw: uncomment types below when updated to handle failures

  // TODO: jjw: should rewrite older `update` stuff below using spread operator
  // as time allows; much easier to parse mentally, and less prone to errors

  switch (type) {
    case "UNDERWRITER_UPDATE_APPLICATION":
      const index = _.findIndex(state.loanApps, (app: any) => app.id === action.payload.id);
      return update(state, {
        loanApps: {
          [index]: {
            $merge: action.payload,
          },
        },
      });
    case actionTypes.REMOTE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case actionTypes.WVOE_VIEWING_EMPLOYMENT_ID: {
      return {
        ...state,
        loading: false,
        wvoeHurdleViewingEmploymentID: action.employmentIndex,
      };
    }
    case actionTypes.APP_LOAD_SUCCESS: {
      const { loanApps } = state;
      const { app } = action;

      const appIdx = appIdToIdx(loanApps, app.id);

      if (appIdx === -1) {
        const apps = [app];
        if (loanApps) {
          apps.unshift(...loanApps);
        }
        return {
          ...state,
          loading: false,
          loanApps: apps,
        };
      }

      return update(state, {
        loading: {
          $set: false,
        },
        loanApps: {
          [appIdx]: {
            $merge: app,
          },
        },
      });
    }
    case actionTypes.APP_LOAD_FAILURE: {
      return update(state, {
        loading: {
          $set: false,
        },
      }); // TODO: revert on failure
    }
    case actionTypes.HURDLE_OVERRIDE_CREATE_REQUEST: {
      const { loanApps } = state;
      const {
        appId,
        hurdleName,
        hurdleOverrideTempId,
        hurdleOverrideStatus,
        hurdleOverrideValues,
      } = action;

      const appIdx = appIdToIdx(loanApps, appId);
      const hurdleIdx = _.findIndex(loanApps[appIdx].hurdles, (h: any) => h.name === hurdleName);

      const override = {
        id: hurdleOverrideTempId, // temp id before server responds
        values: hurdleOverrideValues,
        status: hurdleOverrideStatus,
      };

      return update(state, {
        loanApps: {
          [appIdx]: {
            hurdles: {
              [hurdleIdx]: {
                override: { $set: override },
              },
            },
          },
        },
      });
    }
    case actionTypes.HURDLE_OVERRIDE_CREATE_SUCCESS: {
      const { loanApps } = state;
      const { appId, hurdleOverrideTempId, hurdleOverrideRealId } = action;

      const appIdx = appIdToIdx(loanApps, appId);
      const hurdleIdx = overrideIdToHurdleIdx(loanApps[appIdx].hurdles, hurdleOverrideTempId);

      const override = {
        id: hurdleOverrideRealId, // replace with real id on response
      };

      return update(state, {
        loanApps: {
          [appIdx]: {
            hurdles: {
              [hurdleIdx]: {
                override: { $merge: override },
              },
            },
          },
        },
      });
    }
    /*
    case actionTypes.HURDLE_OVERRIDE_CREATE_FAILURE: {
      return state; // TODO: revert on failure
    }
    */
    case actionTypes.HURDLE_OVERRIDE_UPDATE_REQUEST: {
      const { loanApps } = state;
      const { appId, hurdleOverrideId, hurdleOverrideStatus, hurdleOverrideValues } = action;

      const appIdx = appIdToIdx(loanApps, appId);
      const hurdleIdx = overrideIdToHurdleIdx(loanApps[appIdx].hurdles, hurdleOverrideId);

      const override = {
        values: hurdleOverrideValues,
        status: hurdleOverrideStatus,
      };

      return update(state, {
        loanApps: {
          [appIdx]: {
            hurdles: {
              [hurdleIdx]: {
                override: { $merge: override },
              },
            },
          },
        },
      });
    }
    /*
    case actionTypes.HURDLE_OVERRIDE_UPDATE_FAILURE: {
      return state; // TODO: revert on failure
    }
    */
    case actionTypes.HURDLE_OVERRIDE_DELETE_REQUEST: {
      const { loanApps } = state;
      const { appId, hurdleOverrideId } = action;

      const appIdx = appIdToIdx(loanApps, appId);
      const hurdleIdx = overrideIdToHurdleIdx(loanApps[appIdx].hurdles, hurdleOverrideId);

      return update(state, {
        loanApps: {
          [appIdx]: {
            hurdles: {
              [hurdleIdx]: {
                override: { $set: null },
              },
            },
          },
        },
      });
    }
    /*
    case actionTypes.HURDLE_OVERRIDE_DELETE_FAILURE: {
      return state; // TODO: revert on failure
    }
    */
    case actionTypes.DISCLOSURES_ADD_REQUEST: {
      const { loanApps } = state;
      const { appId, disclosure } = action;

      const appIdx = appIdToIdx(loanApps, appId);

      return update(state, {
        loanApps: {
          [appIdx]: {
            disclosures: {
              $splice: [[0, 0, disclosure]],
            },
          },
        },
      });
    }

    /*
    case actionTypes.DISCLOSURES_ADD_FAILURE: {
      return state; // TODO: revert on failure
    }
    */

    case SEARCH_DATA_LOADED: {
      return {
        ...state,
        loading: false,
      };
    }

    case actionTypes.FINISH_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }

    case LOCATION_CHANGE:
      return {
        ...state,
        previousLocation: state.currentLocation,
        currentLocation: action.payload.pathname,
      };

    case actionTypes.SET_CURRENT_HURDLE_NAME: {
      return {
        ...state,
        currentHurdleName: action.hurdleName,
      };
    }

    case actionTypes.CLEAR_CURRENT_HURDLE_NAME: {
      return {
        ...state,
        currentHurdleName: null,
      };
    }

    default: {
      return state;
    }
  }
};
